// Smart-redirect, deep-linking, browser-language and marketing-pixel helpers for the Smartlink page.

export const detectOS = () => {
  const ua = window.navigator.userAgent || window.navigator.vendor || "";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  if (/android/i.test(ua)) return "android";
  return "other";
};

export const getPreferredPlatformKey = (os) => {
  if (os === "ios") return "apple_music";
  if (os === "android") return "spotify";
  return null;
};

export const detectBrowserLang = () => {
  const lang = (navigator.language || navigator.languages?.[0] || "es").toLowerCase();
  if (lang.startsWith("en")) return "en";
  if (lang.startsWith("pt")) return "pt";
  return "es";
};

// Converts a standard Spotify web URL into its native app URI scheme so the
// Spotify app opens directly on mobile instead of the browser (when installed).
// Other platforms (Apple Music, YouTube Music, TikTok, Instagram, Amazon Music...)
// already rely on their own universal/app links when opening the https:// URL directly,
// so no conversion is applied for those.
export const getDeepLink = (platformKey, url) => {
  if (!url) return url;
  if (platformKey === "spotify") {
    const match = url.match(/open\.spotify\.com\/(?:intl-\w+\/)?(track|album|artist|playlist)\/([a-zA-Z0-9]+)/);
    if (match) return `spotify:${match[1]}:${match[2]}`;
  }
  return url;
};

export const isMobileDevice = () => detectOS() === "ios" || detectOS() === "android";

const loadedPixels = new Set();

export const injectMarketingPixels = () => {
  const metaPixelId = process.env.REACT_APP_META_PIXEL_ID;
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const tiktokPixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;

  if (metaPixelId && !loadedPixels.has("meta")) {
    loadedPixels.add("meta");
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", metaPixelId);
    window.fbq("track", "PageView");
    /* eslint-enable */
  }

  if (gaId && !loadedPixels.has("ga")) {
    loadedPixels.add("ga");
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", gaId);
  }

  if (tiktokPixelId && !loadedPixels.has("tiktok")) {
    loadedPixels.add("tiktok");
    /* eslint-disable */
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
      ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.load = function (e) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
        var o = d.createElement("script"); o.type = "text/javascript"; o.async = !0; o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = d.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a);
      };
      ttq.load(tiktokPixelId);
      ttq.page();
    })(window, document, "ttq");
    /* eslint-enable */
  }
};
